module.exports = __webpack_public_path__ + "static/media/Display-Ads.4118e332.png";